import { formatFormFieldReport } from '../ProblemsReporter.js';

export const execute = (node, context) => {

  const {
    executionPlatformLabel,
    reporter,
    category
  } = context;

  if ([ 'group', 'dynamiclist' ].includes(node.type) && node.verticalAlignment && node.verticalAlignment !== 'start')
  {
    const errorMessage = `Vertical alignment is not supported by ${executionPlatformLabel}, and will render as top-aligned.`;
    reporter.report(formatFormFieldReport(node, errorMessage, category));
  }

  return true;
};
